import ajax from './ajax'

// 获取当前机器人数量
export const getRobot = () => {
  return ajax.get(`/api/v1/robot/count`)
}

// 检查机器人宝宝名字
export const checkRobotName = ({action, name}) => {
  return ajax.get(`/api/v1/robots?action=${action}&name=${name}`)
}

// 检查机器人主人名字
export const checkMasterName = ({action, owner}) => {
  return ajax.get(`/api/v1/robots?action=${action}&owner=${owner}`)
}

// 创建机器人接口
export const addRobot = ({name, sex, group, birthday, avatar, use, owner}) => {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('sex', sex)
  formData.append('group', group)
  formData.append('birthday', birthday)
  formData.append('avatar', avatar)
  formData.append('use', use)
  formData.append('owner', owner)
  return ajax.post(`/api/v1/member/current/robot`, formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取机器人接口
export const getRobotList = () => {
  return ajax.get(`/api/v1/robots`)
}

// 获取技能商品价格列表
export const getShopSkill = ({robotId}) => {
  return ajax.get(`/api/v1/robots/${robotId}/skills`)
}

// 聊天页面对话接口
export const getChat = ({uuid, question}) => {
  return ajax.post(`/api/v1/chat`, {uuid, question}, {
    'Content-Type': 'application/json'
  })
}

// 获取机器人技能
export const getRobotskill = ({robotId}) => {
  return ajax.get(`/api/v1/robot/${robotId}/knowledge/skills`)
}

// 获取技能价格
export const getSkillPrice = ({robotId, skillIds}) => {
  return ajax.get(`/api/v1/robots/${robotId}/skills/${skillIds}/price`)
}

// 购买技能商品
export const buySkill = ({robotId, skillIds, count, price}) => {
  const formData = new FormData()
  formData.append('count', count)
  formData.append('price', price)
  return ajax.post(`/api/v1/robots/${robotId}/skills/${skillIds}/order`, formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 更新技能开关 1-可用 2-禁用
export const updateSkill = ({robotId, skillId, state}) => {
  const params = new URLSearchParams()
  params.append('state', `${state}`)
  return ajax.put(`/api/v1/robots/${robotId}/skills/${skillId}`, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取剩余调用次数
export const getcallTimes = ({robotId}) => {
  return ajax.get(`/api/v1/robot/${robotId}/call-times`)
}

// 获取调用次数价格
export const getcallPrices = ({robotId, times}) => {
  return ajax.get(`/api/v1/robot/${robotId}/call-times/price?times=${times}`)
}

// 购买调用次数
export const updateOrdertimes = ({robotId, times, count}) => {
  const params = new URLSearchParams()
  params.append('times', `${times}`)
  params.append('count', `${count}`)
  return ajax.post(`/api/v1/robot/${robotId}/call-times/order`, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/robot.js